















































































































































































/* eslint-disable */
/**
 * Standard side menu.
 * @displayName Side Menu
 */
import { DEFAULT_SEVERITIES } from "../SeverityIcon/SeverityModel";
import SeverityIcon from "../SeverityIcon/SeverityIcon.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import SeverityInterface from "../SeverityIcon/SeverityInterface";
import BadgeMenuNotification from "../BadgeMenuNotification.vue";
import { BrandingInterface } from "../../../common-vue-components";
@Component({
    name: "q-left-menu",
    components: {
        SeverityIcon,
        BadgeMenuNotification,
    },
})
export default class QuantumMenu extends Vue {
    /**
     * Pass in the title, icon and router path.
     */
    @Prop({
        default: [
            {
                title: "Host",
                icon: "mdi-view-dashboard",
                link: "dashboard",
                notification: {
                    color: "#d12021",
                    text: "!",
                    tooltip: "change password",
                },
            },
            {
                title: "Virtual Machines",
                tooltip: {
                    text: "Nodes",
                    enabled: () => false,
                },
                icon: "mdi-cube-outline",
                link: "vms",
                notification: {
                    severity: "success",
                    tooltip: "change password",
                },
            },
            {
                title: "Configuration",
                icon: "mdi-settings",
                items: [
                    {
                        title: "Network",
                        icon: "mdi-server-network",
                        link: "configuration#network",
                        tooltip: {
                            text: "Nodes",
                            enabled: () => false,
                        },
                        notification: {
                            color: "#d12021",
                            text: "9",
                            tooltip: "change password",
                        },
                    },
                    {
                        title: "Network2",
                        icon: "mdi-server-network",
                        link: "configuration#network",
                        tooltip: {
                            text: "Nodes",
                            enabled: () => false,
                        },
                        notification: {
                            severity: "critical",
                            tooltip: "change password",
                        },
                    },
                ],
            },
            {
                title: "Health",
                icon: "mdi-heart-pulse",
                link: "health",
                tooltip: {
                    text: "Nodes",
                    enabled: () => false,
                },
                notification: {
                    severity: "critical",
                    tooltip: "change password",
                },
            },
        ],
    })
    public readonly menuItems?: [];
    /**
     * Unused
     */
    @Prop()
    public readonly header?: string;
    /**
     * logo tool tip
     */
    @Prop()
    public readonly logoTooltip?: string;
    /**
     * Minify value hooked in to component with this property - TODO
     */
    @Prop()
    public readonly minified?: boolean;
    /**
     * Branding object passed in to component
     */
    @Prop(Object)
    public readonly branding?: BrandingInterface;
    /**
     * Route to go to when the logo is clicked.  This is a vue-route
     * so can be either a string or a vue-route link object
     */
    @Prop({default: () => ({name: "home"}), type: [String, Object]})
    public readonly logoRoute?: { name: string; param?: object } | string;
    /**
     * Pass in the title, icon and router path for buttons on the bottom left
     */
    @Prop()
    public readonly bottomMenuItems?: [];
    /**
     * Pass width for navigation drawer
     */
    @Prop({default: 238, type: Number})
    public readonly width?: number;
    /**
     * Switches the menu between its expanded and minified form
     */
    @Prop({default: false, type: Boolean})
    public readonly minify?: boolean;
    /**
     * Switches the menu between its expanded and minified form
     */
    @Prop(Boolean)
    public readonly showToolTips?: boolean;

    public drawer: boolean = true;
    public severities: SeverityInterface = DEFAULT_SEVERITIES;

    public highestNot(m: any) {
        let count: number = 0;
        const highestSeverityNot: any = {weight: 0, color: "#d12021"};
        for (const el of m) {
            if (!!el.notification && (!!el.notification.text || !!el.notification.severity)) {
                if (!highestSeverityNot.severity && !highestSeverityNot.text) {
                    if (!!el.notification.severity) {
                        highestSeverityNot.severity = el.notification.severity;
                        highestSeverityNot.weight = this.severities[
                            el.notification.severity
                            ].weight;
                    } else if (!!el.notification.text) {
                        highestSeverityNot.text = el.notification.text;
                        highestSeverityNot.color = el.notification.color;
                        highestSeverityNot.weight = 0;
                    }
                } else if (highestSeverityNot.severity || highestSeverityNot.text) {
                    if (
                        !!el.notification.severity &&
                        this.severities[el.notification.severity].weight >
                        highestSeverityNot.weight
                    ) {
                        highestSeverityNot.severity = el.notification.severity;
                        highestSeverityNot.weight = this.severities[el.notification.severity].weight;
                    } else if (!!el.notification.text) {
                        // Do nothing
                    }
                }
                count++;
                if (
                    el.notification.severity &&
                    this.severities[el.notification.severity].weight >
                    highestSeverityNot.weight
                ) {
                    highestSeverityNot.weight = this.severities[
                        el.notification.severity
                        ].weight;
                }
            } else {
                return {};
            }
            // If there is more than one notification, display the count and use the highest severity color
            if (count > 1) {
                // Change the general color to the severity color if the highest notification is a severity icon
                if (highestSeverityNot.severity) {
                    highestSeverityNot.color = this.severities[
                        highestSeverityNot.severity
                        ].color;
                }
                highestSeverityNot.text = count.toString();
                highestSeverityNot.tooltip = "multiple notifications";
            }
        }
        if (count === 1) {
            // Change the profile text to 1 if only 1 text alert
            if (highestSeverityNot.text) {
                highestSeverityNot.text = "1";
            }
        }
        return highestSeverityNot;
    }

    public get logoSubHeader(): string {
        return (this.branding && this.branding.logoSubHeader) || "";
    }

    public goTo(action: boolean | undefined | Function) {
        if (action instanceof Function) {
            return action();
        }
    }

    public isDisabled(isDisabled: boolean | undefined | Function) {
        if (isDisabled instanceof Function) {
            return isDisabled();
        } else {
            return false;
        }
    }

    public isDisabledTooltip(
        showToolTips: false | undefined | { text: string; enabled: Function }
    ) {
        return !showToolTips || (showToolTips.text && showToolTips.enabled());
    }

    public isConfigurationRoute() {
        return this.$route.name === "configuration";
    }

    public themePath() {
        return this.$vuetify.theme.dark ? "dark" : "light";
    }

    public logo() {
        let logoPath = require("../../../public/static/themes/" +
            this.themePath() +
            "/quantum/images/logo.png");

        if (this.branding && this.branding.logo) {
            logoPath = this.branding.logo;
        }

        return logoPath;
    }

    public logoMini() {
        let logoMiniPath = require("../../../public/static/themes/" +
            this.themePath() +
            "/quantum/images/logo-mini.png");

        if (this.branding && this.branding.logoMini) {
            logoMiniPath = this.branding.logoMini;
        }

        return logoMiniPath;
    }

    public isVisible(option: any) {
        if (option === null || option === undefined) {
            return true;
        } else {
            return option;
        }
    }

    public broadcast(item: any): void {
        this.$emit(item.title.toLowerCase()); // don't know if we need it but I left it for backward compatible

        if (item.notification && !item.notification.dont_clear_on_click) {
            item.notification = {};
        }
    }
}
